import React, {useState, useContext} from 'react';
import {AppContext} from './Context';

// ProgressBar Titles and datas
const baseProgressStep = [
	{idx: 1, number: "1/7", pourcentage: 14, title: "Informations personnelles"},
	{idx: 2, number: "2/7", pourcentage: 28, title: "Mes volontés essentielles"},
	{idx: 3, number: "3/7", pourcentage: 28, title: "Autres dispositions"},
	{idx: 4, number: "4/7", pourcentage: 42, title: "Désignation du mandataire"},
	{idx: 5, number: "5/7", pourcentage: 71, title: "Récapitulatif de vos volontés"},
	{idx: 6, number: "6/7", pourcentage: 85, title: "Pièce d’identité"},
	{idx: 7, number: "7/7", pourcentage: 100, title: "Signature"}

]

/**
 * Progress Bar
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>>}
 */
const ProgressBar = React.forwardRef((props, ref) => {

	const {currentStep, steps, dispatchStepEvent, scrollToTop} = useContext(AppContext);
	const [progressSteps, setProgressSteps] = useState(baseProgressStep);

	const handlePrevStep = () => {
		if (currentStep > 0) {
			dispatchStepEvent('PREV_STEP');
			scrollToTop();
		} else {
			dispatchStepEvent('BACK_TO_HOME');
		}

	}

	const handleNextStep = () => {
		dispatchStepEvent('NEXT_STEP');
		scrollToTop();
	}


	return <div ref={ref} className="row center ">
		<div className="card-banner">

			<div className="col-xs-12 top box shadow">
				<div className="row center wB raz-pt">
					<div className="steps_v2 fullwidth tunnel_v2 ">
						<ol className="list-steps el-">

							{
								progressSteps.map((progress, index) =>
									<li key={progress.idx} data-idx={progress.idx}
										className={`item-5 ${steps[index].is_current ? 'current' : ''} ${steps[index].is_validate ? 'validate' : ''}  ${'fill-' + progress.pourcentage} `}>
										<div className="rounded">
											<div className="circle white"><span
												className="hide-xs show-lg">{progress.idx}</span><span
												className="hide-lg">{progress.number}</span></div>
											<div className="circle grey">
												<div className="segment"></div>
											</div>
										</div>
										<div className="container-infos">
											<span className="title">{progress.title}</span>
										</div>
									</li>)


							}

						</ol>
					</div>
				</div>
				<div className="nav-mobile hide-lg" style={{justifyContent: 'space-between'}}>
					<span id="prev" onClick={handlePrevStep}><i className="fun-picto fun-picto-arrow-right"></i> Retour</span>
					<div style={{
						display: "flex",
						flexDirection: "column",
						gap: "16px"
					}}>
						{currentStep === 2 && (
							<span id="" onClick={handleNextStep}>Suivant<i style={{marginLeft: '10px'}} className="fa fa-arrow-right"></i></span>
						)}

						<span id="next" onClick={props.saveForm} className={` ${props.isReadyForSaving ? '' : 'wait'}`}>Sauvegarder <br/> et Quitter</span>

					</div>

				</div>
			</div>
		</div>
	</div>;
});

export default ProgressBar;
